export const IS_LOGGED_IN_COOKIE_NAME = 'isLoggedIn'
export const DATETIME_FORMAT = 'MMMM Do YYYY, h:mm a'
export const DATE_FORMAT = 'MMMM D, YYYY'
export const TIME_FORMAT = 'h:mm a'
export const SHORT_DATE_FORMAT = 'MMM. D, YYYY'
export const MONTH_DAY_FORMAT = 'MMMM D'
export const SHORT_MONTH_DAY_FORMAT = 'MMM D'
export const SHORT_DATETIME_FORMAT = 'MMM. D, YYYY @ h:mm a'
export const SHORT_DATETIME_NO_YEAR_FORMAT = 'MMM. D @ h:mm a'

export const EDITOR_MODE_HTML = 'html'
export const EDITOR_MODE_MARKDOWN = 'markdown'

export const POST_TYPE_POST = 'POST'
export const POST_TYPE_LINK = 'LINK'
export const POST_TYPE_IMAGE = 'IMAGE'
export const POST_TYPE_POLL = 'POLL'

export const BILLING_TERM_MONTH = 'MONTHLY'
export const BILLING_TERM_YEAR = 'YEARLY'

export const daysOfTheWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
]

export const MAX_DAILY_SEARCHES = 5

export const MAX_SUBMISSIONS_PER_POST = 100

export const UPLOAD_LOCATION_REDDIT = 'reddit'
export const UPLOAD_LOCATION_IMGUR = 'imgur'
export const UPLOAD_LOCATION_REDGIFS = 'redgifs'
export const UPLOAD_LOCATIONS = {
  [UPLOAD_LOCATION_REDDIT]: 'Reddit',
  [UPLOAD_LOCATION_IMGUR]: 'Imgur',
  [UPLOAD_LOCATION_REDGIFS]: 'RedGIFs'
}

// Reddit limits the number of images in a gallery to 20.
export const MAX_MEDIA_PER_GALLERY = 20
